<template>
    <div>
        <div v-if="!show_print">
                         <non-tourist-certification-form v-if="step === 1" @proceed="proceed"
                                                         :certification-data="certification_data"></non-tourist-certification-form>
                <non-tourist-certification-confirm v-if="step === 2" @proceed="viewPrint"
                                                   @back="back"
                                                   :certification-data="certification_data"></non-tourist-certification-confirm>


        </div>
        <div v-else>
            <certification-print :data="printData"></certification-print>
        </div>
    </div>
</template>

<script>
    import NonTouristCertificationForm from './NonTouristCertificationForm'
    import NonTouristCertificationConfirm from "./NonTouristCertificationConfirm";
    import CertificationPrint from "./CertificationPrint";

    export default {
        name: "NepaleseCertification",
        data() {
            return {
                certification_data: {},
                step: 1,
                show_print: false,
                printData: {}
            }
        },
        methods: {
            proceed(data) {
                this.certification_data = data;
                this.step = 2;
            },
            back() {
                this.step = 1;
            },
            viewPrint(data) {
                this.printData = data;
                this.show_print = true;
            }
        },
        components: {
            CertificationPrint,
            NonTouristCertificationForm,
            NonTouristCertificationConfirm
        }
    }
</script>
